export class BusinessUnitModel {
    public id: number;
    public locationId: number;
    public businessUnitName: string;
    public locationName: string;
    public businessUnitTypeDisplayValue: string;
    public parentBusinessUnitId: number;
    public branches: BusinessUnitModel[];
}
